import { render, staticRenderFns } from "./CategoryEditView.vue?vue&type=template&id=becc5120"
import script from "./CategoryEditView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryEditView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports